// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53b439f9","577":"9ae76e79","951":"309a7870"}[chunkId] + ".chunk.js";
};